module.exports = __webpack_public_path__ + "static/media/comment-img.f64a0513.png";